module.exports = __webpack_public_path__ + "assets/media/morning.1b871d27.mp3";